/**
 * toast theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/toast.ts
 */
import { defineSlotRecipe } from '@chakra-ui/react';
import { toastAnatomy } from '@chakra-ui/react/anatomy';
import { button } from './button';
export const toast = defineSlotRecipe({
    slots: toastAnatomy.keys(),
    base: {
        root: {
            w: {
                base: 'calc(100dvw - 32px)',
                lg: '360px',
            },
            gap: '0px',
            px: '16px',
            py: '12px',
            rounded: '8px',
            borderWidth: '2px',
            borderColor: 'text.default',
            '&[data-type=success]': {
                borderColor: 'state.success',
                bg: 'state.successBg',
                boxShadow: '2px 2px 0px 0px #0DD4B0',
                color: 'text.default',
            },
            '&[data-type=error]': {
                borderColor: 'state.error',
                bg: 'state.errorBg',
                boxShadow: '2px 2px 0px 0px #FA3952',
                color: 'text.default',
            },
        },
        title: {
            textStyle: 'body2Bold',
            mb: '4px',
            marginEnd: '30px',
            '[data-type=success] &': {
                color: 'state.success',
            },
            '[data-type=error] &': {
                color: 'state.error',
            },
        },
        description: {
            textStyle: 'body3',
            marginEnd: '30px',
            opacity: 1,
        },
        closeTrigger: {
            top: '12px',
            insetEnd: '12px',
            cursor: 'pointer',
            ...button.variants?.variant.icon,
        },
    },
    variants: {},
    compoundVariants: [],
    defaultVariants: {},
});
